import { BuildingReviewFormView } from 'desktop/module/building-review/form/view';
import { BuildingReviewFormViewFactory } from 'desktop/module/building-review/form/view.factory';

const service = BuildingReviewFormViewFactory();

export function BuildingReviewFormViewService(): BuildingReviewFormView {
  return service;
}
